import React, { useEffect } from "react";
import { withErrorBoundary } from "@lululemon/mwa-common";
import { LoadGoogleMapsJSApi } from "@lululemon/ufs-shared";
import BopisAccordion from ".";
import { useUserCountry } from "../hooks/useLocale";

// BOPISTODO - add dynamic import for this (ssr: false)
const BopisAccordionConnector = ({
  activeSku,
  useUserLocation,
  processNodeEnv,
  googleMapsApiKey,
  useNearbyBopisStores,
  setIsBopisModalOpen,
  deliveryType,
  isSkuAvailableInSelectedBopisStore,
  selectedStore,
  selectedSkuQuantities,
  isAccordionOpen,
  onRadioButtonChangeHandler,
  onAccordionClickHandler
}) => {
  const userCountry = useUserCountry();
  const { userLocation, getUserCityState, getUserAddress, hasCookieError } =
    useUserLocation();
  const shouldFetchInventory = true;
  const { nearbyBopisStores } = useNearbyBopisStores({
    activeSku,
    shouldFetchInventory
  });

  useEffect(() => {
    if (
      !userLocation.address &&
      !userLocation.city &&
      activeSku?.size &&
      isAccordionOpen
    ) {
      getUserCityState();
    }
  }, [isAccordionOpen, activeSku?.size]);

  useEffect(() => {
    if (hasCookieError) {
      getUserAddress();
    }
  }, [hasCookieError]);

  const sortedNearbyBopisStores = () => {
    if (nearbyBopisStores?.length === 0) {
      return selectedStore.id && isSkuAvailableInSelectedBopisStore
        ? [selectedStore]
        : [];
    }

    if (selectedStore.id && isSkuAvailableInSelectedBopisStore) {
      const isSelectedStoreOneOfThreeNearest = nearbyBopisStores
        .slice(0, 3)
        .some((store) => store.id === selectedStore.id);

      return isSelectedStoreOneOfThreeNearest
        ? [
            selectedStore,
            ...nearbyBopisStores
              .slice(0, 3)
              .filter((store) => store.id !== selectedStore.id)
          ]
        : [selectedStore, ...nearbyBopisStores.slice(0, 2)];
    }

    return nearbyBopisStores.slice(0, 3);
  };

  return (
    <>
      <LoadGoogleMapsJSApi
        processNodeEnv={processNodeEnv}
        googleMapsApiKey={googleMapsApiKey}
      />
      <BopisAccordion
        activeSku={activeSku}
        deliveryType={deliveryType}
        handleChangeLocations={() => setIsBopisModalOpen(true)}
        handleClick={onAccordionClickHandler}
        isAccordionOpen={isAccordionOpen}
        nearbyBopisStores={
          nearbyBopisStores != null
            ? sortedNearbyBopisStores()
            : nearbyBopisStores
        }
        selectedStoreId={selectedStore.id}
        selectedSkuQuantities={selectedSkuQuantities}
        userCountry={userCountry}
        userLocation={userLocation}
        onChangeHandler={onRadioButtonChangeHandler}
      />
    </>
  );
};

export default withErrorBoundary({
  componentName: "BopisAccordionConnector"
})(BopisAccordionConnector);
